import {Vue, Component} from 'vue-property-decorator';
import {Observer} from "mobx-vue";
import Welfare from '@/components/Welfare'
import WelfareStore from '@/store/WelfareStore';
import router from '@/router';

@Observer
@Component
export default class NoviceWelfare extends Vue {
  
  constructor(props: any) {
    super(props)
  }
  
  state = {
    WelfareStore
  }
  
 async mounted () {
  
    if (sessionStorage.getItem('openId')) {
      await this.state.WelfareStore.checkWelfare(sessionStorage.getItem('openId'))
    } else {
      window.addEventListener('setItem', async ()=> {
        await this.state.WelfareStore.checkWelfare(sessionStorage.getItem('openId'))
      })
    }
  
  }
  
  render() {
    return (
      <div>
        <Welfare dataSource={this.state.WelfareStore.successTips}  type={this.state.WelfareStore.pickStatus}/>
      </div>
    )
  }
  
}
